import React, { Component } from 'react';
import AccountsRender from '../components/accounts/accounts';
import AccountDial from '../components/accounts/accountDial';
import { RequestInfoGet, pageSrc, serverUrl } from '../lib/funApp/general'
import { MDBIcon } from 'mdbreact';
import { Container, Row, Col, Card } from "react-bootstrap";

const basePath = '/src/accounts'
let targetUrl = basePath

if(pageSrc && pageSrc.indexOf(basePath) === 0){
  targetUrl = serverUrl + pageSrc
}else{
  targetUrl = serverUrl + basePath
}

class AccountsGet extends Component {

  state = {
    accounts: [],
    links: {},
    loading: true,
    error: null
  }

  componentDidMount() {
    fetch(targetUrl ,RequestInfoGet)
    .then(res => res.json())
    .then((data) => {
      this.setState({ links: data._links, accounts: data.items, loading: false, error: null })
    })
    .catch((error) => {
      this.setState({ loading: false, error: error })
    })
  }

  renderStatus(message) {
    return (
      <>
        <Container>
          <Row className="TitleContainer">
            <Col style={{ padding: "10px"}}>
              <h4><MDBIcon icon="cash-register" className="mr-2 ml-4" />Contas</h4>
            </Col>
            <Col>
              <AccountDial />
            </Col>
          </Row>
        </Container>
        <Container className="MainContainer">
          <Row>
            <Col>
              <Card>
                <Card.Body className="text-center">{message}</Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    )
  }

  render() {
    return (
      <>
      {this.state.loading ? (
        this.renderStatus('Carregando...')
      ) : this.state.error ? (
        this.renderStatus('Erro ao carregar contas.')
      ) : this.state.accounts[0] !== undefined ? (
        <AccountsRender accounts={[this.state.accounts,this.state.links]} />
      ) : (
        this.renderStatus('Nenhuma conta encontrada.')
      )}
      </>
    )
  }

}

export default AccountsGet;

/**/
